export { default as defaultTheme } from './default.theme'



// WEBPACK FOOTER //
// ./src/themes/ideal/index.js